<template lang="pug">
.service-package-page
  .content
    .hero
      .brand-row
        img.logo(src="@/assets/logo.png")
        span 袋鼠照护
      .hero-kicker {{ page.kicker }}
      h1 {{ page.title }}
      p.hero-subtitle {{ page.subtitle }}
      .hero-visual
        img(:src="page.image" :alt="page.imageAlt")
        .visual-note
          span.note-label {{ page.visualLabel }}
          span.note-text {{ page.visualText }}
      .price-block(v-if="page.price")
        .price
          span.currency ¥
          span.amount {{ page.price }}
          span.unit {{ page.priceUnit }}
        .price-note {{ page.priceNote }}
      .hero-tags
        span(v-for="tag in page.tags" :key="tag") {{ tag }}

    .section
      .section-title
        span.index 01
        h2 {{ page.firstTitle }}
      .reason-list
        .reason-item(v-for="item in page.reasons" :key="item.title")
          span.dot
          .reason-copy
            h3 {{ item.title }}
            p {{ item.desc }}

    .section
      .section-title
        span.index 02
        h2 {{ page.outcomeTitle }}
      .outcome-strip
        .outcome-card(v-for="item in page.outcomes" :key="item.title")
          span.outcome-icon {{ item.icon }}
          span.outcome-title {{ item.title }}
          span.outcome-desc {{ item.desc }}

    .section
      .section-title
        span.index 03
        h2 {{ page.serviceTitle }}
      .service-list
        .service-item(v-for="item in page.services" :key="item.title")
          span.service-mark {{ item.mark }}
          .service-copy
            h3 {{ item.title }}
            p {{ item.desc }}

    .section(v-if="page.plans")
      .section-title
        span.index 04
        h2 {{ page.planTitle }}
      .plan-list
        .plan-card(v-for="plan in page.plans" :key="plan.name")
          .plan-head
            .plan-name
              span.plan-badge {{ plan.badge }}
              h3 {{ plan.name }}
            .plan-price
              span.currency ¥
              span.amount {{ plan.price }}
          p.plan-desc {{ plan.desc }}
          .plan-tags
            span(v-for="tag in plan.tags" :key="tag") {{ tag }}
          .plan-points
            .plan-point(v-for="point in plan.points" :key="point")
              span.dot
              span {{ point }}

    .section(v-else)
      .section-title
        span.index 04
        h2 {{ page.deliverTitle }}
      .deliver-box
        .deliver-row(v-for="item in page.deliver" :key="item.label")
          span.label {{ item.label }}
          span.value {{ item.value }}

    .section
      .section-title
        span.index 05
        h2 {{ page.noteTitle }}
      .rule-list
        .rule-item(v-for="rule in page.rules" :key="rule") {{ rule }}

    .section
      .section-title
        span.index 06
        h2 {{ page.chooseTitle }}
      .choice-list
        .choice-item(v-for="item in page.choices" :key="item.scene")
          span.scene {{ item.scene }}
          span.suggestion {{ item.suggestion }}

    .bottom-action
      .bottom-copy
        span.bottom-title {{ page.bottomTitle }}
        span.bottom-desc {{ page.bottomDesc }}
      button.buy-button(type="button" @click="handleAction") {{ page.actionText }}
</template>

<script>
const pageMap = {
    nearby: {
        kicker: '石家庄周边家庭',
        title: '一次看清楚，后面照护才有方向',
        subtitle: '宝宝回家后，家长最怕的不是辛苦，是不知道自己做得对不对。这个服务会先把喂养、睡眠、体重和训练这些关键问题盯起来；需要上门时，照护师到家里把问题看清楚、方法教到位。',
        image: require('@/assets/pay2/feature-baby.png'),
        imageAlt: '早产宝宝居家照护',
        visualLabel: '核心价值',
        visualText: '发现问题，改对方法，后面照护不再每天靠猜。',
        price: '',
        priceUnit: '',
        priceNote: '',
        tags: ['周边专属', '视频为主', '可预约上门'],
        firstTitle: '家长最容易卡在哪',
        reasons: [
            { title: '看着没大问题，但不知道哪里可能已经偏了', desc: '吃奶姿势、睡眠环境、训练动作，家长很难自己判断有没有做到位。' },
            { title: '问题很多，每天都在零散处理', desc: '今天问奶量，明天问睡眠，后天问训练，但没有一条清楚的照护线。' },
            { title: '家里人做法不一样', desc: '妈妈、宝爸、老人各有一套方法，宝宝照护最怕标准不统一。' }
        ],
        outcomeTitle: '一次上门真正解决什么',
        outcomes: [
            { icon: '查', title: '发现隐藏问题', desc: '把喂养、睡眠、环境、训练一起看。' },
            { icon: '改', title: '现场改到位', desc: '抱姿、喂养姿势、训练动作现场纠正。' },
            { icon: '定', title: '定接下来怎么做', desc: '给后面一段时间的照护重点。' }
        ],
        serviceTitle: '我们怎么陪你',
        services: [
            { mark: '看', title: '先看宝宝这几天的变化', desc: '体重、奶量、睡眠、大便、反流、训练视频都可以发过来，照护师先帮你判断重点。' },
            { mark: '讲', title: '视频里把操作讲明白', desc: '喂养姿势、抬头训练、抱姿、被动操，不只讲原则，会看你家实际怎么做。' },
            { mark: '跟', title: '不是问完就结束', desc: '宝宝月龄在变，照护重点也会变。我们会根据记录和反馈，提醒下一阶段该注意什么。' }
        ],
        planTitle: '石家庄周边可选服务包',
        plans: [
            {
                badge: '先守住',
                name: '周边基础视频版',
                price: 1680,
                desc: '适合先把喂养、体重、睡眠和训练这些基础问题管起来。',
                tags: ['90天重点照护', '+3个月基础陪伴', '4次视频指导', '含体重秤'],
                points: [
                    '图文、电话和视频为主，先把日常问题管起来',
                    '重点看体重、喂养、睡眠和训练动作',
                    '后续确实需要到家看，可以再预约上门'
                ]
            },
            {
                badge: '带上门',
                name: '周边安心版',
                price: 1980,
                desc: '适合家里问题比较多，需要照护师到家里看一次、改一次、定一套方法。',
                tags: ['90天重点照护', '+3个月基础陪伴', '1次周边上门', '4次视频指导'],
                points: [
                    '一次上门集中发现和解决居家照护问题',
                    '给接下来 1 个月的喂养、睡眠和训练重点',
                    '上门时间由照护师提前确认'
                ]
            },
            {
                badge: '更连续',
                name: '周边深度视频版',
                price: 2680,
                desc: '适合宝宝风险更高，家长希望前 6 个月持续有人帮忙看趋势、纠动作、调计划。',
                tags: ['180天个性化', '+6个月基础陪伴', '1次周边上门', '6次视频指导'],
                points: [
                    '持续看体格追赶和神经发育节奏',
                    '关键节点安排一次周边上门',
                    '适合胎龄小、出生体重低、家长比较焦虑的家庭'
                ]
            }
        ],
        noteTitle: '购买前你需要知道',
        rules: [
            '上门需要提前预约，照护师会先确认时间和地址。',
            '大部分日常问题会优先通过图文、电话或视频处理。',
            '如果照护师判断需要现场看，会建议你预约上门。',
            '如果宝宝出现明显不舒服、发热、呼吸异常等情况，建议先去医院。'
        ],
        chooseTitle: '怎么选',
        choices: [
            { scene: '想先把前 3 个月守住', suggestion: '周边基础视频版' },
            { scene: '家里问题多，想一次集中看清楚', suggestion: '周边安心版' },
            { scene: '希望前 6 个月持续有人跟进', suggestion: '周边深度视频版' }
        ],
        bottomTitle: '石家庄周边服务包',
        bottomDesc: '日常线上跟进，必要时预约上门。',
        actionText: '咨询周边服务',
        actionPath: '/pay2/extra-visit/shijiazhuang-nearby'
    },
    growth: {
        kicker: '早产儿生长发育咨询',
        title: '体重在涨，不代表追赶节奏就一定合适',
        subtitle: '很多家长每天都在看奶量和体重，但还是不踏实。这个咨询包会帮你把宝宝近期的体重、喂养、睡眠和大便放在一起看，告诉你现在重点该盯什么。',
        image: '/pay2/smart-scale-1.jpg',
        imageAlt: '智能体重秤记录宝宝体重',
        visualLabel: '先看数据',
        visualText: '把体重、奶量和睡眠放在一起看，才知道追赶节奏对不对。',
        price: '',
        priceUnit: '',
        priceNote: '开通前可先与照护师确认服务周期和价格',
        tags: ['体重曲线', '喂养调整', '复查提醒'],
        firstTitle: '哪些情况适合',
        reasons: [
            { title: '体重在涨，但不知道涨得够不够', desc: '早产宝宝不只看有没有长，还要看增长速度和月龄阶段是否匹配。' },
            { title: '奶量总想调，但不敢乱调', desc: '吃奶慢、反流、胀气、睡不好，都会影响追赶节奏，需要一起看。' },
            { title: '不是医院用户，也想先问问', desc: '适合从小红书、朋友介绍或社群进入的家庭，先从线上咨询开始。' }
        ],
        outcomeTitle: '买完以后，家长会更清楚什么',
        outcomes: [
            { icon: '重', title: '体重怎么看', desc: '不是只看今天多少斤，而是看趋势。' },
            { icon: '奶', title: '奶量怎么调', desc: '结合吃奶表现，不让家长乱加乱减。' },
            { icon: '查', title: '何时该复查', desc: '异常波动时提醒及时线下确认。' }
        ],
        serviceTitle: '我们会怎么帮你看',
        services: [
            { mark: '长', title: '看增长节奏', desc: '结合出生情况、纠正月龄和近期体重记录，看宝宝是不是在合适的追赶节奏里。' },
            { mark: '吃', title: '看喂养是否拖后腿', desc: '奶量、吃奶速度、反流、胀气、睡眠都会影响体重，不能只单独看一个数字。' },
            { mark: '调', title: '给下一步建议', desc: '告诉你接下来重点看什么、奶量是否需要调整、什么情况需要复查。' }
        ],
        deliverTitle: '买完以后怎么服务',
        deliver: [
            { label: '服务方式', value: '图文咨询为主，必要时电话或视频确认' },
            { label: '家长准备', value: '近期体重、奶量、睡眠、大便、复查报告' },
            { label: '服务结果', value: '喂养调整建议、居家观察重点、复查提醒' },
            { label: '适用范围', value: '适合日常生长和喂养问题，不处理急症' }
        ],
        noteTitle: '需要提醒你的事',
        rules: [
            '如果宝宝精神差、吃奶明显下降、发热或呼吸异常，建议先去医院。',
            '线上咨询适合帮你判断日常照护方向，不能替代医生诊断。',
            '如果只靠文字说不清，照护师会建议电话、视频或线下评估。',
            '每个宝宝追赶速度不同，我们会重点看趋势，不用某一个固定数字判断好坏。'
        ],
        chooseTitle: '适合你吗',
        choices: [
            { scene: '主要担心体重、奶量、反流', suggestion: '适合这个包' },
            { scene: '主要担心姿势、张力、抬头', suggestion: '看神经发育咨询包' },
            { scene: '需要到家看喂养姿势和环境', suggestion: '建议上门服务' }
        ],
        bottomTitle: '早产儿生长发育咨询包',
        bottomDesc: '服务周期和价格开通前确认。',
        actionText: '咨询开通'
    },
    neuro: {
        kicker: '早产儿神经发育咨询',
        title: '在家练之前，先确认宝宝现在适合怎么练',
        subtitle: '很多家长担心错过发育窗口，也担心自己练错。这个咨询包会结合宝宝视频，看姿势、张力、抬头、追视和动作质量，再告诉你这个阶段先练什么、哪些动作不用急。',
        image: require('@/assets/pay2/feature-baby.png'),
        imageAlt: '早产宝宝神经发育观察',
        visualLabel: '先看动作',
        visualText: '训练前先确认姿势、张力和动作质量，避免在家越练越偏。',
        price: '',
        priceUnit: '',
        priceNote: '开通前可先与照护师确认服务周期和价格',
        tags: ['视频看动作', '训练纠错', '阶段重点'],
        firstTitle: '哪些情况适合',
        reasons: [
            { title: '网上训练很多，不知道该做哪个', desc: '早产宝宝要看纠正月龄和当前能力，不能照搬足月宝宝训练。' },
            { title: '觉得宝宝姿势不太对', desc: '头偏、身体后仰、手握拳、抬头困难，这些细节需要看宝宝真实动作。' },
            { title: '每天都在练，但不知道有没有练对', desc: '训练不是次数越多越好，动作质量、力度和时机都很重要。' }
        ],
        outcomeTitle: '买完以后，家长会更清楚什么',
        outcomes: [
            { icon: '看', title: '动作哪里不对', desc: '看姿势、张力、抬头和追视。' },
            { icon: '练', title: '这个阶段练什么', desc: '按宝宝现在能力安排训练重点。' },
            { icon: '纠', title: '家长怎么做', desc: '训练动作不靠猜，视频里纠正。' }
        ],
        serviceTitle: '我们会怎么帮你看',
        services: [
            { mark: '姿', title: '看宝宝自己的动作', desc: '看平躺、俯卧、抱起时的姿势表现，判断有没有需要重点关注的地方。' },
            { mark: '动', title: '看阶段能力', desc: '抬头、转头、追视、手部打开、抓握准备，会结合月龄看下一步怎么做。' },
            { mark: '练', title: '看家长怎么训练', desc: '如果动作做不到位，会告诉你手放哪里、力度多大、一次做多久。' }
        ],
        deliverTitle: '买完以后怎么服务',
        deliver: [
            { label: '服务方式', value: '上传视频评估，必要时视频连线纠错' },
            { label: '家长准备', value: '宝宝自然状态视频、训练视频、纠正月龄和复查信息' },
            { label: '服务结果', value: '当前训练重点、动作纠错建议、下一阶段观察点' },
            { label: '适用范围', value: '适合居家训练指导，不替代线下专科评估' }
        ],
        noteTitle: '需要提醒你的事',
        rules: [
            '如果宝宝出现抽搐、反应差、明显异常姿势等情况，建议先去医院。',
            '线上视频可以看动作质量，但不能替代医生诊断或康复治疗。',
            '如果视频看不完整，照护师会建议上门或线下专科评估。',
            '训练建议要按宝宝状态执行，不建议家长自行加量。'
        ],
        chooseTitle: '适合你吗',
        choices: [
            { scene: '担心姿势、张力、抬头、追视', suggestion: '适合这个包' },
            { scene: '主要担心体重和奶量', suggestion: '看生长发育咨询包' },
            { scene: '家长训练动作一直做不准', suggestion: '建议视频纠错或上门' }
        ],
        bottomTitle: '早产儿神经发育咨询包',
        bottomDesc: '服务周期和价格开通前确认。',
        actionText: '咨询开通'
    }
};

export default {
    props: {
        type: {
            type: String,
            default: ''
        }
    },
    computed: {
        currentType () {
            const routeType = this.type || this.$route.params.type || this.$route.query.type || 'nearby';
            return pageMap[routeType] ? routeType : 'nearby';
        },
        page () {
            return pageMap[this.currentType];
        }
    },
    methods: {
        handleAction () {
            if (this.page.actionPath) {
                this.$router.push(this.page.actionPath);
                return;
            }
            if (this.$toast) {
                this.$toast('请联系照护师确认适合的服务包');
            }
        }
    }
};
</script>

<style lang="sass" scoped>
.service-package-page
  min-height: 100vh
  background: #F5F7F4
  color: #24352E
  padding-bottom: 92px

.content
  max-width: 760px
  margin: 0 auto
  padding: 16px 14px 0

.hero
  border-radius: 0 0 24px 24px
  background: linear-gradient(160deg, #FDF8EF 0%, #EFF7F0 58%, #FFFFFF 100%)
  padding: 18px
  border: 1px solid #E1EBDD

.brand-row
  display: flex
  align-items: center
  gap: 8px
  color: #157866
  font-size: 14px
  font-weight: 700

.logo
  width: 26px
  height: 26px
  border-radius: 6px

.hero-kicker
  display: inline-flex
  margin-top: 18px
  padding: 5px 9px
  border-radius: 4px
  background: #E8F7F8
  color: #067C83
  font-size: 12px
  font-weight: 700

h1
  margin: 12px 0 0
  color: #203733
  font-size: 24px
  line-height: 1.28
  font-weight: 800

.hero-subtitle
  margin: 12px 0 0
  color: #617069
  font-size: 14px
  line-height: 1.7

.hero-visual
  position: relative
  margin-top: 14px
  min-height: 150px
  border-radius: 10px
  overflow: hidden
  background: #EEF7F0
  border: 1px solid #DCE8DE

  img
    width: 100%
    height: 190px
    display: block
    object-fit: cover
    background: #F8FAF6

.visual-note
  position: absolute
  left: 10px
  right: 10px
  bottom: 10px
  display: grid
  gap: 3px
  padding: 10px
  border-radius: 8px
  background: rgba(255, 255, 255, 0.92)
  backdrop-filter: blur(8px)
  box-shadow: 0 8px 18px rgba(36, 53, 46, 0.12)

.note-label
  color: #05AEB7
  font-size: 12px
  font-weight: 900

.note-text
  color: #203733
  font-size: 13px
  font-weight: 800
  line-height: 1.45

.price-block
  margin-top: 14px
  padding: 12px
  border-radius: 8px
  background: #FFFFFF
  border: 1px solid #E4ECE5

.price
  display: flex
  align-items: flex-end
  color: #D96A4C

  .currency
    margin-bottom: 4px
    font-size: 14px
    font-weight: 800

  .amount
    font-size: 30px
    line-height: 1
    font-weight: 900

  .unit
    margin: 0 0 4px 4px
    color: #6C756F
    font-size: 13px
    font-weight: 700

.price-note
  margin-top: 4px
  color: #6C756F
  font-size: 12px
  line-height: 1.45

.hero-tags
  display: flex
  flex-wrap: wrap
  gap: 8px
  margin-top: 14px

  span
    padding: 6px 9px
    border-radius: 4px
    background: #FFFFFF
    border: 1px solid #DCE8DE
    color: #315C4C
    font-size: 12px
    font-weight: 700

.section
  margin-top: 14px
  padding: 16px
  border-radius: 8px
  background: #FFFFFF
  border: 1px solid #E6EEF0

.section-title
  display: flex
  align-items: center
  gap: 10px
  margin-bottom: 12px

  .index
    width: 30px
    height: 30px
    border-radius: 15px
    display: flex
    align-items: center
    justify-content: center
    background: #05C2CB
    color: #FFFFFF
    font-size: 12px
    font-weight: 800
    flex-shrink: 0

  h2
    margin: 0
    color: #203733
    font-size: 18px
    line-height: 1.35
    font-weight: 800

.reason-list,
.service-list,
.rule-list,
.choice-list,
.plan-list
  display: grid
  gap: 10px

.outcome-strip
  display: grid
  grid-template-columns: repeat(3, minmax(0, 1fr))
  gap: 8px

.outcome-card
  min-height: 118px
  padding: 10px
  border-radius: 8px
  background: #F6FBFB
  border: 1px solid #DCEEEF
  display: flex
  flex-direction: column
  align-items: flex-start
  gap: 6px

.outcome-icon
  width: 30px
  height: 30px
  border-radius: 15px
  display: flex
  align-items: center
  justify-content: center
  background: #05C2CB
  color: #FFFFFF
  font-size: 13px
  font-weight: 900

.outcome-title
  color: #203733
  font-size: 13px
  font-weight: 900
  line-height: 1.35

.outcome-desc
  color: #617069
  font-size: 12px
  line-height: 1.45

.reason-item
  display: flex
  gap: 10px
  padding: 12px
  border-radius: 8px
  background: #F8FAF6

.dot
  width: 6px
  height: 6px
  margin-top: 8px
  border-radius: 50%
  background: #05C2CB
  flex-shrink: 0

.reason-copy
  h3
    margin: 0
    color: #203733
    font-size: 15px
    line-height: 1.45
    font-weight: 800

  p
    margin: 6px 0 0
    color: #617069
    font-size: 13px
    line-height: 1.65

.service-item
  display: grid
  grid-template-columns: 36px 1fr
  gap: 10px
  padding: 12px
  border-radius: 8px
  background: #F6FBFB
  border: 1px solid #E3F1F1

.service-mark
  width: 36px
  height: 36px
  border-radius: 18px
  display: flex
  align-items: center
  justify-content: center
  background: #05C2CB
  color: #FFFFFF
  font-size: 15px
  font-weight: 900

.service-copy
  h3
    margin: 0
    color: #203733
    font-size: 15px
    line-height: 1.45
    font-weight: 800

  p
    margin: 6px 0 0
    color: #617069
    font-size: 13px
    line-height: 1.65

.plan-card
  padding: 14px
  border-radius: 8px
  background: #F8FAF6
  border: 1px solid #DFE9DF

.plan-head
  display: flex
  justify-content: space-between
  gap: 12px
  align-items: flex-start

.plan-badge
  display: inline-flex
  padding: 4px 7px
  border-radius: 4px
  background: #FFF3DF
  color: #B85824
  font-size: 11px
  font-weight: 800

.plan-name
  min-width: 0

  h3
    margin: 7px 0 0
    color: #203733
    font-size: 17px
    line-height: 1.35
    font-weight: 800

.plan-price
  display: flex
  align-items: flex-end
  color: #D96A4C
  white-space: nowrap

  .currency
    margin-bottom: 3px
    font-size: 13px
    font-weight: 800

  .amount
    font-size: 25px
    line-height: 1
    font-weight: 900

.plan-desc
  margin: 10px 0 0
  color: #617069
  font-size: 13px
  line-height: 1.65

.plan-tags
  display: flex
  flex-wrap: wrap
  gap: 6px
  margin-top: 10px

  span
    padding: 5px 7px
    border-radius: 4px
    background: #FFFFFF
    border: 1px solid #E4ECE5
    color: #426154
    font-size: 11px
    font-weight: 700

.plan-points
  display: grid
  gap: 8px
  margin-top: 12px

.plan-point
  display: flex
  gap: 8px
  color: #52655D
  font-size: 13px
  line-height: 1.6

.deliver-box
  border-radius: 8px
  border: 1px solid #E6EEF0
  overflow: hidden

.deliver-row
  display: grid
  grid-template-columns: 78px 1fr
  gap: 10px
  padding: 12px
  border-bottom: 1px solid #EEF6F6

  &:last-child
    border-bottom: 0

  .label
    color: #05AEB7
    font-size: 13px
    font-weight: 800

  .value
    color: #52655D
    font-size: 13px
    line-height: 1.6

.rule-item
  padding: 10px 12px
  border-radius: 6px
  background: #F6F7F9
  color: #52655D
  font-size: 13px
  line-height: 1.6

.choice-item
  display: grid
  grid-template-columns: 1.12fr 0.88fr
  gap: 10px
  padding: 12px
  border-radius: 8px
  background: #FFF9E6
  color: #6B5A1F
  font-size: 13px
  line-height: 1.55

.scene
  font-weight: 700

.suggestion
  color: #B85824
  font-weight: 900

.bottom-action
  position: fixed
  left: 0
  right: 0
  bottom: 0
  z-index: 10
  display: flex
  align-items: center
  justify-content: space-between
  gap: 12px
  padding: 12px 14px calc(12px + env(safe-area-inset-bottom))
  background: rgba(255, 255, 255, 0.96)
  border-top: 1px solid #E4ECE5
  box-shadow: 0 -8px 18px rgba(36, 53, 46, 0.08)

.bottom-copy
  display: flex
  flex-direction: column
  min-width: 0

.bottom-title
  color: #203733
  font-size: 14px
  font-weight: 800

.bottom-desc
  margin-top: 3px
  color: #6A776F
  font-size: 11px
  line-height: 1.4

.buy-button
  height: 42px
  padding: 0 18px
  border: 0
  border-radius: 21px
  background: #05C2CB
  color: #FFFFFF
  font-size: 14px
  font-weight: 800
  white-space: nowrap

@media (min-width: 720px)
  .content
    padding-top: 24px

  .hero
    border-radius: 24px

  h1
    max-width: 560px
    font-size: 30px

  .hero-visual
    min-height: 220px

    img
      height: 260px

  .plan-list
    grid-template-columns: repeat(3, minmax(0, 1fr))

  .plan-head
    flex-direction: column

  .bottom-action
    left: 50%
    max-width: 760px
    transform: translateX(-50%)
    border-radius: 18px 18px 0 0
</style>
